import { useRecoilValue } from "recoil"
import { styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { T3_en, T3_ko } from "../../../style/constant"

const TraumPath = () => {
	const currentLang = useRecoilValue(langState)
	const Text = useRecoilValue(langSelector)
	return(
		<Container currentLang={currentLang}>
			<Wrapper>
				<TraumFuture currentLang={currentLang}>{Text.traumPath.text}</TraumFuture>
				<Arrow src={"/imgs/about/arrowDown.png"} alt="arrowDown"></Arrow>
			</Wrapper>
		</Container>
	)
}


export default TraumPath

type Props = {
	currentLang : boolean
}

const Container = styled.section<Props>`
	width:1200px;
	height:942px;
	margin:${props => props.currentLang ? `627px auto 97px`:`690px auto 97px`};
`

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

const TraumFuture = styled.p<Props>`
	white-space: pre-line;
	${props => props.currentLang ? 
	`
		${T3_ko}
	`:
	`
		${T3_en}
	`}

`

const Arrow = styled.img`
	width:40px;
	height:40px;
	margin-right:32px;
`